import { useState } from "react";
import { BookOpen } from "lucide-react";

export const SafeImg = ({ src, alt = "", className = "", fallbackLabel, ...rest }) => {
  const [err, setErr] = useState(false);
  if (err || !src) {
    return (
      <div className={`${className} bg-bm-sand/50 flex flex-col items-center justify-center gap-2 text-bm-muted`}
        data-testid="img-fallback" role="img" aria-label={alt || "Image unavailable"}>
        <BookOpen className="w-8 h-8" strokeWidth={1.5} />
        {fallbackLabel && <span className="text-xs font-semibold px-2 text-center line-clamp-2">{fallbackLabel}</span>}
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} onError={() => setErr(true)} {...rest} />;
};
